import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import "@/ch.css";
import { BRAND } from "@/brand";
import { GoogleButton } from "@/pages/AuthPages";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { LanguageSwitch, useLang } from "@/i18n";

export const AuthLayout = ({ children, title, subtitle }) => {
  const { t } = useLang();
  return (
  <div className="ch">
    <div className="auth" data-testid="auth-layout">
      <div style={{ position: "absolute", top: 12, right: 12, zIndex: 5 }}><LanguageSwitch /></div>
      <aside className="ab"><div className="lg0" translate="no"><img src={BRAND.logo} alt="FILIT" className="lgi" data-testid="auth-logo" />FILIT Compliance Hub</div><h2>{t("Stay compliant.")}<br />{t("Without the chasing.")}</h2>
        <ul><li><b>{t("Never miss a deadline")}</b>{t("Reminders by email before every due date.")}</li><li><b>{t("Set up by experts")}</b>{t("V.A reviews your business and builds your compliance list.")}</li><li><b>{t("Everything in one place")}</b>{t("Licences, returns, receipts and proof, filed and searchable.")}</li></ul></aside>
      <div className="af"><div className="afi">{title && <h1>{t(title)}</h1>}{subtitle && <p className="mu">{t(subtitle)}</p>}<div style={{ marginTop: 18 }}>{children}</div></div>
        <p className="cpy" translate="no" data-testid="auth-copyright">{BRAND.copyright}</p></div>
    </div>
  </div>
  );
};

export const Fld = ({ id, label, type = "text", value, onChange, err, testId, ...x }) => (
  <div className="fl"><label className="lb" style={{ marginTop: 0 }} htmlFor={`f-${id}`}>{label}</label>
    <input className="sel" id={`f-${id}`} type={type} value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={testId} {...x} />
    {err && <small className="er" data-testid={`${testId}-error`}>{err}</small>}</div>
);

export default function Login() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [er, setEr] = useState({});
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const { t } = useLang();
  if (user) return <Navigate to="/" replace />;
  const submit = async (e) => {
    e.preventDefault();
    const v = { e: /^\S+@\S+\.\S+$/.test(email.trim()) ? "" : t("Enter a valid email address"), p: password ? "" : t("Enter your password") };
    setEr(v); setError("");
    if (v.e || v.p) return;
    setBusy(true);
    try { await api.post("/auth/login", { email: email.trim(), password }); const { data } = await api.get("/auth/me"); setUser(data); navigate("/"); }
    catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <AuthLayout title="Welcome back" subtitle="Sign in to your FILIT Compliance Hub account.">
      <GoogleButton label={t("Sign in with Google")} />
      <div className="or">{t("or")}</div>
      <form onSubmit={submit} noValidate>
        <Fld id="e" label={t("Email")} type="email" value={email} onChange={setEmail} err={er.e} testId="login-email-input" autoComplete="email" />
        <Fld id="p" label={t("Password")} type="password" value={password} onChange={setPassword} err={er.p} testId="login-password-input" autoComplete="current-password" />
        <p style={{ textAlign: "right", margin: "8px 0 0" }}><Link to="/forgot-password" className="lk" data-testid="login-forgot-link">{t("Forgot password?")}</Link></p>
        {error && <div className="msg" data-testid="login-error">{error}</div>}
        <button type="submit" className="b" disabled={busy} data-testid="login-submit-button">{busy ? t("Signing in…") : t("Sign in")}</button>
      </form>
      <p className="mu" style={{ textAlign: "center", marginTop: 16 }}>{t("New here?")} <Link to="/register" className="lk" data-testid="login-register-link">{t("Create an account")}</Link></p>
    </AuthLayout>
  );
}
